/**
 * Retire le SEO statique injecté au build (shell CRA) une fois React monté.
 * Évite les canonical / hreflang dupliqués (#1120 v2) et la fenêtre sans H1 visible (#1118 v2).
 */
export function stripMarketingSeoShell(doc: Document = document): void {
  doc.getElementById('blog-seo-static')?.remove();
  doc.querySelectorAll('[data-marketing-crawler-chrome]').forEach((el) => el.remove());
  doc.querySelectorAll('[data-blog-seo]').forEach((el) => el.remove());
}

function marketingHeroMounted(doc: Document): boolean {
  return Boolean(
    doc.querySelector('#root h1.lp-hero__title') ??
      doc.querySelector('#root h1') ??
      doc.querySelector('#root main h1')
  );
}

/**
 * Ne retire pas le shell avant le premier H1 React : le prerender est en display:none,
 * donc un strip synchrone au boot laisse l’humain sans titre jusqu’au paint (#1118 v2 /en/ mobile).
 */
export function scheduleStripMarketingSeoShellAfterReactHero(
  doc: Document = document,
  opts?: { maxWaitMs?: number }
): void {
  const maxWaitMs = opts?.maxWaitMs ?? 15_000;
  const started = typeof performance !== 'undefined' ? performance.now() : Date.now();

  const tryStrip = () => {
    if (marketingHeroMounted(doc)) {
      stripMarketingSeoShell(doc);
      return true;
    }
    const elapsed =
      (typeof performance !== 'undefined' ? performance.now() : Date.now()) - started;
    if (elapsed >= maxWaitMs) {
      stripMarketingSeoShell(doc);
      return true;
    }
    return false;
  };

  if (tryStrip()) return;

  const raf =
    typeof requestAnimationFrame === 'function'
      ? requestAnimationFrame
      : (cb: FrameRequestCallback) => window.setTimeout(() => cb(Date.now()), 16);

  const loop = () => {
    if (!tryStrip()) raf(loop);
  };
  raf(loop);
}
